export { default as MainC } from './components/main';
export { default as TasksC } from './components/tasks';



// WEBPACK FOOTER //
// src/modules/dispositivos/component.js